import React from 'react';
// import { useDrag } from 'react-dnd';
import useDrag from '../../Hooks/useDrag';
import { addClassNames } from '../../Functions/Helper/Component';
import './Draggable.scss'

const DraggingContext = React.createContext(null);
export const useDraggingContext = () => React.useContext(DraggingContext);

export default function Draggable({
    type,
    data,
    className:_className,
    children,
    onDragStart,
    onDragStop,
    onDropOver,
    onDropLeave,
    onDrop,
    ItemComponent,
    gripRef,
    ...rest
}) {
    const dragOptions = React.useMemo(() => {    
        return {
            onDragStart,
            onDragStop,
            onDrop,
            onDropOver, 
            onDropLeave,
            gripRef
        };
    }, [onDragStart, onDragStop, onDropOver, onDropLeave, gripRef, onDrop]);

    const [drag, {isDragging, setDraggable}] = useDrag(type, data, dragOptions);
    const provideVal = React.useMemo(() => ({setDraggable, isDragging}), [setDraggable, isDragging]);
    const props = {
        ...rest,
        ref: drag,
        className: addClassNames("draggable", _className, isDragging? "active" : "")
    };

    if (ItemComponent) {
        return (
            <DraggingContext.Provider value={provideVal}>
                <ItemComponent {...props}>
                        {children}
                </ItemComponent>
            </DraggingContext.Provider>
        );
    } else return (
            <DraggingContext.Provider value={provideVal}>
                <div {...props}>
                    {children}
                </div>
            </DraggingContext.Provider>
        );
}


